<template>
    <div
        class="inline-flex items-center rounded-3xl px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider"
        :class="classString"
    >
        {{ badge[1] }}
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
    badge: {
        type: Array,
        required: true
    }
})

const classString = computed(() => {
    if (props.badge[0] === 'GREEN') {
        return 'bg-emerald-600/90 text-white'
    } else if (props.badge[0] === 'RED') {
        return 'bg-red-600/90 text-white'
    } else if (props.badge[0] === 'YELLOW') {
        return 'bg-amber-600/90 text-white'
    } else if (props.badge[0] === 'GRAY') {
        return 'bg-gray-300/90 text-gray-900'
    } else if (props.badge[0] === 'BLUE') {
        return 'bg-blue-600/90 text-white'
    } else {
        throw new Error('Unknown contract state')
    }
})
</script>
